// axios
import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_URL
})

instance.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem('accessToken');

export default instance;
